/*@ngInject*/
const RuleModel = function ($rootScope, $timeout, coreMediator, configurationConstant, ruleRepository) {

    var ruleModel = {};
    var variableValueList = [];

    this.reset = function (ruleId) {
        if (!_.isNil(ruleId)) {
            ruleModel[ruleId] = {
                rule: null,
                hasUnsavedChanges: false
            };
        } else {
            ruleModel = {};
        }
    };

    this.buildRule = function (ruleId) {
        this.reset(ruleId);

        return ruleRepository.findRuleById(ruleId).then(function (rule) {
            this.updateRule(rule);
        }.bind(this));
    };

    this.getRule = function (ruleId) {
        var model = ruleModel[ruleId];
        return model.rule;
    };

    this.setUnsavedChanges = function (ruleId, hasUnsavedChanges) {
        var model = ruleModel[ruleId];
        model.hasUnsavedChanges = hasUnsavedChanges;
    };

    this.hasUnsavedChanges = function (ruleId) {
        var model = ruleModel[ruleId];
        return model.hasUnsavedChanges;
    };

    this.updateRule = function (rule) {
        var model = {
            rule: _.cloneDeep(rule),
            hasUnsavedChanges: false
        };

        ruleModel[rule.id] = model;

        $rootScope.$broadcast(configurationConstant.event.RULE_MODEL_UPDATED, rule.id);
    };

    this.getVariableValueList = function () {
        return variableValueList;
    };

    this.setVariableValueList = function (newVariableValueList) {
        variableValueList.splice(0, variableValueList.length);
        _.each(newVariableValueList, function (variableValue) {
            variableValueList.push(variableValue);
        });
    };
};

angular.module('ums.configuration')
    .service('ruleModel', RuleModel);
